import { create } from "zustand";
import { Alert, defaultAlertDuration } from "@/types/Alert";
import { generateId } from "@/helpers/utils";

interface AlertsStore {
  alerts: { id: string; alert: Alert }[];
  addAlert: (alert: Alert) => void;
  removeAlertById: (alertId: string) => void;
}

export const useAlertsStore = create<AlertsStore>()((set, get) => ({
  alerts: [],
  addAlert: (alert) => {
    const newAlertId = "Alert-" + generateId();
    set((state) => ({
      alerts: [...state.alerts, { id: newAlertId, alert }],
    }));
    setTimeout(
      () => {
        get().removeAlertById(newAlertId);
      },
      alert.duration ? alert.duration : defaultAlertDuration,
    );
  },
  removeAlertById: (alertId) => {
    set((state) => ({
      alerts: state.alerts.filter((a) => a.id != alertId),
    }));
  },
}));
